import React from "react";
import { T, fonts } from "../../theme/tokens";

export function NdcLogo({ size = 22, style }) {
  const iconH = Math.round(size * 36 / 22);
  const iconW = Math.round(size * 42 / 22);

  return (
    <div style={{ display: "flex", alignItems: "center", gap: Math.round(size * 0.6), ...style }}>
      <svg width={iconW} height={iconH} viewBox="0 0 56 48" fill="none">
        <rect x="8" y="28" width="10" height="16" rx="5" transform="skewX(-12)" fill={T.accent} opacity="0.4" />
        <rect x="24" y="18" width="10" height="26" rx="5" transform="skewX(-12)" fill={T.accent} opacity="0.7" />
        <rect x="40" y="8" width="10" height="36" rx="5" transform="skewX(-12)" fill={T.accent} opacity="1" />
      </svg>
      <span style={{
        fontFamily: fonts.display,
        fontWeight: 700,
        fontSize: size,
        letterSpacing: "0.5px",
        color: T.textDark,
      }}>
        Neil Dunlop Consulting
      </span>
    </div>
  );
}
